interface BudgetPermissionsThProps {
    labelText: string;
    helpText?: string
}

function BudgetPermissionsTh({ labelText, helpText }: BudgetPermissionsThProps) {
    return (
        <th>
            <div className="th-inner-wrapper">
                <span>{labelText}</span>
                {helpText && <span className={"help-block"}>{helpText}</span>}
            </div>
        </th>
    );
}

export default BudgetPermissionsTh; 